import React, { FC, useEffect, useRef, useState } from 'react'

import { LoadingDots, Typography } from '@smarty-nx/ds'
import cn from 'classnames'

import classes from './index.module.scss'
import PageHead from '../../components/PageHead'
import { SiteContainer } from '../../components/shared'
import withApp from '../../components/withApp/withApp'
import { CONFIG } from '../../config'

const NetworkStatusChecker: FC = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const currentIframe = iframeRef.current
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (currentIframe) {
      setLoaded(true)
    }
  }, [currentIframe])

  return (
    <SiteContainer className={classes.siteContainer}>
      {!loaded && (
        <div className={classes.loadingState}>
          <LoadingDots className={classes.loadingDotsWidth} />
          <Typography variant="Kollektif/Small">Loading...</Typography>
        </div>
      )}
      <div
        className={cn(classes.iframeContent, {
          [classes.iframeContentVisible]: loaded,
        })}
      >
        <div className={classes.container}>
          <Typography
            component="h1"
            variant="Kollektif/Mega"
            className={classes.title}
          >
            Network Status Checker
          </Typography>
          <Typography variant="Kollektif/Medium" className={classes.subtext}>
            Get more information about the current network situation in your
            area
          </Typography>
        </div>

        <iframe
          ref={iframeRef}
          title="network-status-checker"
          src={CONFIG.NETWORK_STATUS_CHECKER_LINK}
          height={600}
          onLoad={() => setLoaded(true)}
          data-testid="network-status-checker-iframe"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          style={{
            width: '100%',
            border: 'none',
            margin: '0px auto',
            marginTop: '-50px',
            background: 'transparent',
            display: 'block',
            overflow: 'hidden',
            paddingTop: 0,
          }}
        />
      </div>
    </SiteContainer>
  )
}

export default withApp(NetworkStatusChecker)

export const Head = ({ location }: { location: { pathname: string } }) => (
  <PageHead
    title="Network status checker"
    description="Check your SMARTY network status for up to date information"
    location={location}
  >
    <meta name="referrer" content="same-origin" />
  </PageHead>
)
